<template>
    <!-- Level 1 panel -->
    <div
        ref="scrollList"
        class="border-t border-gray-DFDFDF scroll-smooth overflow-y-auto cz-hidden lg:block -mt-[1px]"
    >
        <step-option-list-item
            v-for="group in visibleGroups"
            :key="group.code"
            :item-data="group"
        />
    </div>
    <div class="flex flex-col flex-1"></div>
    <div :class="[
        'border-t border-gray-DFDFDF flex justify-center px-[24px] lg:px-[40px] bg-white bg-opacity-80 gap-[12px] bottom-0 sticky',
        'order-2 lg:order-none',
        leadTimeFormatted ? 'py-[24px] pb-[34px] h-[100px] max-h-[100px]' : 'py-[24px] h-[90px] max-h-[90px]',
    ]">
        <save-and-exit-button
            :isDisabled="inErrorState"
        />
        <continue-button
            v-if="saveButtonMode === 'default' || !saveButtonMode"
            :isDisabled="inErrorState"
            @goNext="slideProgress++"
        />

        <div
            v-if="leadTimeFormatted"
            class="absolute bottom-[12px] w-full text-center text-[11px] leading-none flex gap-[6px] justify-center items-center"
        >
            <img src="../assets/images/shipping-icon.svg" class="relative top-[-1px]"/>
            <span>{{leadTimeFormatted}}</span>
        </div>
    </div>
</template>

<script>
    import StepOptionListItem from './StepOptionListItem.vue';
    import ContinueButton from './buttons/ContinueButton.vue';
    import SaveAndExitButton from './buttons/SaveAndExitButton.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            StepOptionListItem,
            ContinueButton,
            SaveAndExitButton,
        },

        computed: {
            saveButtonMode() {
                return this.customizerStore.options.saveButtonMode;
            },

            groupsSeen() {
                return this.customizerStore.groupsSeen;
            },

            visibleGroups() {
                const list = this.customizerStore.buildVisibleGroups({
                    sourceGroups: this.customizerStore.visibleGroups,
                });

                return list;
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            inErrorState() {
                // TODO: REVIEW! Is this a leftover from error states review?
                return false;
            },

            leadTime() {
                return this.customizerStore.leadTime;
            },

            leadTimeFormatted() {
                if (this.leadTime === 0) {
                    return null;
                }

                return this.$t('LEAD_TIME', { weeks: this.leadTime });
            },
        },

        methods: {
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },

            setSelectedGroup(itemData) {
                this.customizerStore.setCurrentGroup(itemData.name);
            },
        },
    };
</script>
